import { useWatch } from 'react-hook-form';

export function useRequiredProposalFieldCheck() {
  const isFieldRequired =
    useWatch({ name: 'nextPublishStatus' }) === 'published';

  return { isFieldRequired };
}
